<template>
  <AuthWrapper>
    <p class="auth-notice">
      <language-setter />
      {{ $t('pages.login.havent-account') }}
      <router-link to="/auth/register">{{ $t('pages.login.sign-up-now') }}</router-link>
    </p>
    <div class="auth-contents">
      <a-form @finish="handleSubmit" :model="formState" layout="vertical">
        <sdHeading as="h3"> {{ $t('pages.login.sign-in') }} </sdHeading>
        <a-form-item name="email" :label="$t('pages.login.email-address')">
          <a-input type="text" v-model:value="formState.email" :placeholder="$t('pages.login.email-address')" />
        </a-form-item>
        <a-form-item name="password" initialValue="123456" :label="$t('pages.login.password')">
          <a-input type="password" v-model:value="formState.password" :placeholder="$t('pages.login.password')" />
        </a-form-item>
        <a-form-item>
          <sdButton class="btn-signin" htmlType="submit" type="primary" size="large">
            {{ isLoading ? $t('common.loading') : $t('pages.login.sign-in') }}
          </sdButton>
        </a-form-item>
        <div class="auth-form-action">
          <router-link class="forgot-pass-link" to="/auth/forgotPassword">
            {{ $t('pages.login.forgot-password') }}
          </router-link>
        </div>
      </a-form>
    </div>
  </AuthWrapper>
</template>
<script>
import { computed, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { AuthWrapper } from './style';
import { useRouter } from 'vue-router';
import LanguageSetter from './overview/LanguageSetter.vue';

const SignIn = {
  name: 'SignIn',
  components: { AuthWrapper, LanguageSetter },
  setup() {
    const { state, dispatch, commit } = useStore();
    const isLoading = computed(() => state.auth.loading);
    const checked = ref(null);
    const router = useRouter();

    const onChange = (checked) => {
      checked.value = checked;
    };

    const formState = reactive({
      email: '',
      password: '',
    });

    const handleSubmit = () => {
      dispatch('login', formState).then((response) => {
        if (state.auth.two_fa_verify) {
          router.push('/auth/2fa');
        } else if (state.auth.login) {
          router.push('/');
        }
      });
    };

    return {
      isLoading,
      checked,
      handleSubmit,
      onChange,
      formState,
    };
  },
};

export default SignIn;
</script>
